import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { Search } from '@indeed/ifl-icons';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';
import { Input } from '../Input/Input.js';
import '@indeed/ifl-css';
import '../../utils/createResponsive.js';
import '../../constants/index.js';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../../utils/warn.js';
import '../../hooks/useCheckValidity.js';
import '../Input/ChipInput.js';
import '../Input/styles.js';
import '../Input/AutosizeInput.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Chip/ChipGroup.js';
import '../Chip/Chip.js';
import 'focus-visible';
import '@emotion/is-prop-valid';
import '@indeed/ihl-use-id';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../../utils/transition.js';
import '../Button/Button.js';
import '../../utils/styled.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../Label/Label.js';
import '../../utils/warnDeprecation.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Flex/Flex.js';
import '../../utils/displayName.js';
import '../Input/InputWrapper.js';
import '../TouchTarget/TouchTarget.js';
import '../Text/Text.js';

const SelectListFilter = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Box, {
    sx: {
      bg: "background",
      isolation: "isolate",
      paddingInline: 4,
      paddingBlockStart: 4,
      marginBlockStart: -4,
      marginInline: -4,
      paddingBlockEnd: 1,
      marginBlockEnd: 1,
      position: "sticky",
      top: -4,
      zIndex: 2
    }
  }, jsx(Input, _extends({
    ref: forwardedRef,
    contentBefore: jsx(Search, {
      "aria-hidden": true
    })
  }, props)));
});

export { SelectListFilter };
